<script setup>
import AlertMessage from '../../../../../../components/AlertMessage.vue';
import { computed, ref } from 'vue';
import AppButton from '../../../../../../components/AppButton.vue';
import { IconEyeExclamation } from '@tabler/icons-vue';

const props = defineProps({
    review: {
        type: Object,
        required: true,
    },
    answers: {
        type: Array,
        required: true,
    },
});

const emit = defineEmits(['handleReview']);

const status = ref('idle');

const submit = async () => {
    status.value = 'processing';
    axios.post(props.review.url, { answers: props.answers }).then((response) => {
        const review = response.data.review;
        message.value = review.message;
        emit('handleReview', review);
        status.value = 'success';
    });
};

const percentCompleted = computed(() => {
    return Math.round((props.answers.filter((a) => a.answer !== null).length / props.answers.length) * 100);
});

const canRequestReview = computed(() => {
    return percentCompleted.value > 70;
});

const message = ref('');
</script>

<template>
    <div>
        <div v-if="['idle', 'processing'].includes(status)">
            <AlertMessage class="mt-5 inline-block" type="info">
                <template v-slot:title>
                    {{ $t('messages.information') }}
                </template>
                <template v-slot:body>
                    {{ $t('messages.request_quiz_review_explanation') }}
                </template>
            </AlertMessage>
            <div>
                <div>
                    <AlertMessage class="mt-5 inline-block" type="alert" v-if="!canRequestReview">
                        <template v-slot:title>
                            {{ $t('messages.information') }}
                        </template>
                        <template v-slot:body>
                            {{ $t('messages.request_quiz_review_disabled_message') }}
                        </template>
                    </AlertMessage>
                </div>
                <AppButton
                    :disabled="!canRequestReview"
                    desired-action
                    @click="submit"
                    element="button"
                    type="button"
                    class="mt-3"
                >
                    {{ $t('messages.request_quiz_review') }}
                </AppButton>
            </div>
        </div>
        <AlertMessage class="mt-5 inline-block" type="info" v-if="['success'].includes(status)">
            <template v-slot:title>
                {{ $t('messages.information') }}
            </template>
            <template v-slot:body>
                <div>{{ message }}</div>
                <IconEyeExclamation class="text-yellow-600 h-6 w-6" v-if="review.is_reviewed_with_details" />
            </template>
        </AlertMessage>
    </div>
</template>
